import React,{useState,useContext} from 'react';
import {NavLink} from 'react-router-dom';
import './../../../assets/scss/style.scss';
import Aux from "../../../hoc/_Aux";
import {firebase} from '../../../firebase.prod'
import { FirebaseContext } from '../../../firebaseContext';
import Breadcrumb from "../../../App/layout/AdminLayout/Breadcrumb";
import { useHistory } from 'react-router';
function SignUp1 () {
    const {firebase} = useContext(FirebaseContext)
    const history = useHistory()
    const [userEmail, setuserEmail] = useState('')
    const [userPassword, setUserPassword] = useState('')
    const isCompleteInputs = userEmail === '' || userPassword === ''


    const handleSignin = (event) => {
        event.preventDefault();
    
        firebase
          .auth()
          .signInWithEmailAndPassword(userEmail, userPassword)
          .then(() => {
            history.push('/');
          })
          .catch((error) => {
            alert(error)
          });
      };

        return(
            <Aux>
                <Breadcrumb/>
                <div className="auth-wrapper">
                    <div className="auth-content">
                        <div className="auth-bg">
                            <span className="r"/>
                            <span className="r s"/>
                            <span className="r s"/>
                            <span className="r"/>
                        </div>
                        <div className="card">
                            <div className="card-body text-center">
                                <div className="mb-4">
                                    <i className="feather icon-unlock auth-icon"/>
                                </div>
                                <h3 className="mb-4">Login</h3>
                                {/* user Input */}
                                {/* user Input */}
                                <div className="input-group mb-3">
                                    <input type="email"  onChange={({ target })=> setuserEmail(target.value)}  className="form-control" placeholder="Email"/>
                                </div>
                                {/* user Input */}
                                <div className="input-group mb-4">
                                    <input type="password"  onChange={({ target })=> setUserPassword(target.value)}  className="form-control" placeholder="password"/>
                                </div>
                                {/* user Input */}
                                {/* user Input */}
                                <div className="form-group text-left">
                                    <div className="checkbox checkbox-fill d-inline">
                                        <input type="checkbox" name="checkbox-fill-1" id="checkbox-fill-a1" />
                                            <label htmlFor="checkbox-fill-a1" className="cr"> Save credentials</label>
                                    </div>
                                </div>
                                <button className="btn btn-primary shadow-2 mb-4" disabled={isCompleteInputs} onClick={handleSignin} >Login</button>
                                <p className="mb-2 text-muted">Forgot password? <NavLink to="/auth/ResetPassword">Reset</NavLink></p>
                            </div>
                        </div>
                    </div>
                </div>
            </Aux>
        );
    
}

export default SignUp1;